.categorySelector {
  display: flex;
  gap: 40px;
}
